import Vue from 'vue'
import Vuex from 'vuex'
import utilities from '@/services/utilities'
import * as api from '@/services/schedules'

Vue.use(Vuex)

export default {
	namespaced: true,
	state: {
		spinnerLoader: false,
		spinnerLoaderLabel: '',
	},
	mutations: {
		SET_STATE(state, payload) {
			Object.assign(state, {
				...payload,
			})
		},
	},
	actions: {
		async GET_REPORT({ commit }, payload) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Obteniendo información',
			})
			return new Promise((resolve, reject) => {
				api
					.getSchedulesReport(payload)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						Vue.prototype.$notification.error({
							message: 'Registro de Asistencia',
							description: utilities.objectValidate(error, 'response.data.message', 'Error al consultar el registro'),
						})
						reject(error)
					})
					.finally(() => {
						commit('SET_STATE', {
							spinnerLoader: false,
						})
					})
			})
		},
		async GET_DELAY_REPORT({ commit }, payload) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Obteniendo información',
			})
			return new Promise((resolve, reject) => {
				api
					.getDelayReport(payload)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						Vue.prototype.$notification.error({
							message: 'Registro de Asistencia',
							description: utilities.objectValidate(error, 'response.data.message', 'Error al consultar los registros'),
						})
						reject(error)
					})
					.finally(() => {
						commit('SET_STATE', {
							spinnerLoader: false,
						})
					})
			})
		},
		async CREATE_SCHEDULE({ commit }, payload) {
			commit('SET_STATE', {
				spinnerLoader: true,
				spinnerLoaderLabel: 'Procesando información',
			})
			return new Promise((resolve, reject) => {
				api
					.createSchedule(payload)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						Vue.prototype.$notification.error({
							message: 'Registro de Asistencia',
							description: utilities.objectValidate(error, 'response.data.message', 'Error al generar el registro'),
						})
						reject(error)
					})
					.finally(() => {
						commit('SET_STATE', {
							spinnerLoader: false,
						})
					})
			})
		},
	},
	getters: {
		spinnerLoader: (state) => state.spinnerLoader,
		spinnerLoaderLabel: (state) => state.spinnerLoaderLabel,
	},
}
